import Vue from 'vue';

const theState = {
    snack: {
        show: false,
        color: 'primary',
        timeout: 3000,
        message: '',
        icon: 'mdi-close',
    },
    defaultSnack: {
        show: false,
        color: 'primary',
        timeout: 3000,
        message: '',
        icon: 'mdi-close | mdi-alert-circle | mdi-check-circle | mdi-alert',
    },
};

const getters = {};
const actions = {};

const mutations = {
    error(state, message) {
        Vue.set(state.snack, 'color', 'error');
        Vue.set(state.snack, 'message', message);
        Vue.set(state.snack, 'show', true);
    },

    success(state, message) {
        Vue.set(state.snack, 'color', 'success');
        Vue.set(state.snack, 'message', message);
        Vue.set(state.snack, 'show', true);
    },

    info(state, message) {
        Vue.set(state.snack, 'color', 'amber');
        Vue.set(state.snack, 'message', message);
        Vue.set(state.snack, 'show', true);
    },
};

export default {
    namespaced: true,
    state: theState,
    getters,
    actions,
    mutations,
};
